(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/shared/hooks/use-remove-member.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/shared/hooks/use-remove-member.js');
'use strict';

const {
  useCallback
} = React;
const {
  removeMember,
  setTeamBalance
} = svs.arena.store.teams.actions;
const {
  deleteMemberAsync
} = svs.arena.service.teamsService;
const {
  showRemoveMemberQuestionDialog,
  showRemoveMemberError
} = svs.arena.pages.teams.dialogs;

const useRemoveMember = function (teamId, teamName, customerId, firstName, lastName) {
  let amount = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
  let isInactive = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
  const dispatch = ReactRedux.useDispatch();
  const onRemoveMember = useCallback(async () => {
    if (await showRemoveMemberQuestionDialog(amount, teamName, firstName, lastName)) {
      const track = {
        category: 'spela-tillsammans',
        action: isInactive ? 'action_members_inactive' : 'action_members',
        opt_label: 'delete'
      };
      svs.components.analytics.trackEvent(track);
      const {
        error,
        data
      } = await deleteMemberAsync(teamId, customerId);
      if (error) {
        showRemoveMemberError(firstName);
        return;
      }
      const {
        syndicateBalance,
        playableAmount
      } = data.syndicateAmounts;
      dispatch(removeMember({
        customerId,
        teamId
      }));
      dispatch(setTeamBalance({
        teamId,
        syndicateBalance,
        playableAmount,
        isMemberActive: false
      }));
    } else {
      const track = {
        category: 'spela-tillsammans',
        action: isInactive ? 'action_members_inactive' : 'action_members',
        opt_label: 'delete_cancel'
      };
      svs.components.analytics.trackEvent(track);
    }
  }, [amount, teamName, firstName, lastName, isInactive, teamId, customerId, dispatch]);
  return {
    onRemoveMember
  };
};
svs.arena.shared.hooks.useRemoveMember = useRemoveMember;

 })(window);